import React, { useEffect } from 'react';

interface AdSenseProps {
  client: string; // Google AdSenseのクライアントID
  slot: string;   // 広告ユニットのスロットID
  format?: string; // 広告フォーマット
  responsive?: boolean; // レスポンシブ対応
  style?: React.CSSProperties;
  className?: string;
}

const AdSense: React.FC<AdSenseProps> = ({
  client,
  slot,
  format = 'auto',
  responsive = true,
  style = {},
  className = ''
}) => {
  useEffect(() => {
    // Google AdSenseのスクリプトが読み込まれているかチェック
    if (typeof window !== 'undefined' && (window as any).adsbygoogle) {
      try {
        (window as any).adsbygoogle.push({});
      } catch (error) {
        console.error('AdSense error:', error);
      }
    }
  }, []);

  return (
    <div className={`ad-container ${className}`} style={style}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={client}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive={responsive}
      />
    </div>
  );
};

export default AdSense;
